/* eslint-disable*/

import { Container, Grid, Box, Typography } from '@material-ui/core'; // eslint-disable-line
import { useSelector } from 'react-redux';
import { currentchannel } from 'feactures/channel/channelSlice';
import CategoryShareLabel from 'components/molecules/dashboard/CategoryShareLabel';
import CategoryShareTable from 'components/molecules/dashboard/CategoryShareTable';
import {
  selectAmazonCategoryShareGraph,
  selectRakutenCategoryShareGraph,
  selectYahooCategoryShareGraph
} from 'feactures/brand/categoryBrandShareSlice';
import BrandItemShareLabel from 'components/molecules/dashboard/BrandItemShareLabel';

const BrandItemShareTable = () => {
  // 実際のデータはuseEffectで取得しreduxへ
  const categoryShareAmazonGraphData = useSelector(
    selectAmazonCategoryShareGraph
  );
  const categoryShareRakutenGraphData = useSelector(
    selectRakutenCategoryShareGraph
  );
  const categoryShareYahooGraphData = useSelector(
    selectYahooCategoryShareGraph
  );
  const channel = useSelector(currentchannel);

  let categoryGraphData = {
    graphdata: [],
    label: [],
    sales: [],
    percentage: []
  };

  if (channel == 1) {
    categoryGraphData = categoryShareAmazonGraphData.graphdata;
  } else if (channel == 2) {
    categoryGraphData = categoryShareRakutenGraphData.graphdata;
  } else if (channel == 3) {
    categoryGraphData = categoryShareYahooGraphData.graphdata;
  }

  return (
    <>
      <Container maxWidth={false}>
        <Grid container rowSpacing={0.3} columnSpacing={1.5} padding={1} my={1}>
          <>
            <Grid itemxs={12} mb={1}>
              <BrandItemShareLabel />
            </Grid>
            <Grid item xs={12}>
              {categoryGraphData.label.length === 0 ? (
                <Box
                  height="400px"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography fontSize={15}>
                    表示できるデータがありません
                  </Typography>
                </Box>
              ) : (
                <>
                  {/* テーブル */}
                  <CategoryShareTable
                    category={categoryGraphData.label}
                    sales={categoryGraphData.sales}
                    percentage={categoryGraphData.percentage}
                    page="brandAnalysis"
                  />
                </>
              )}
            </Grid>
          </>
        </Grid>
      </Container>
    </>
  );
};

export default BrandItemShareTable;
